import Div from "@jumbo/shared/Div/Div";
import { Button, Grid, Switch, Typography } from "@mui/material";
import ListOptions from "app/components/Dropdown/ListOptions";
import {
  codeList,
  genderList,
  outerDiv1,
} from "app/utils/constants/dropdowns.js";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ErrorMessage, Form, Formik } from "formik";
import * as yup from "yup";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { LoadingButton } from "@mui/lab";
import FormTextField1 from "app/components/InputField/FormTextField1";
import ListOptions1 from "app/components/Dropdown/ListOptions1";
import { addClient } from "app/services/apis/addClient";
import { updateClientDetailsAdmin } from "app/services/apis/updateClientDetailsAdmin";

export default function AddClient() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [isSubmitting, setSubmitting] = useState(false);
  const { pathname } = useLocation();
  const data = state;

  const client = {
    first_name: data?.first_name ? data?.first_name : "",
    last_name: data?.last_name ? data?.last_name : "",
    email_id: data?.email_id ? data?.email_id : "",
    gender: data?.gender ? data?.gender : "Select",
    dob: data?.dob ? data?.dob : "",
    mobile_no: data?.mobile_no ? data?.mobile_no : "",
    country_code: data?.country_code ? data?.country_code : "+91",
    status: data?.status == false || data?.status == true ? data?.status : true,
  };
  const validationSchema = yup.object({
    first_name: yup
      .string("Enter First Name")
      .required("First Name is required")
      .matches(
        /^[A-Za-z\s]+$/,
        "First Name must contain only alphabetic characters"
      ),
    last_name: yup
      .string("Enter Last Name")
      .required("Last Name is required")
      .matches(
        /^[A-Za-z\s]+$/,
        "Last Name must contain only alphabetic characters"
      ),
    dob: yup.string().required("Date Of Birth is required"),
    email_id: yup
      .string("Enter your Email ID")
      .email("Enter a valid Email ID")
      .required("Email is required"),
    gender: yup
      .string()
      .required("Gender is required")
      .test(
        "gender-not-select",
        "Please select a valid Gender",
        (value) => value !== "Select"
      ),

    mobile_no: yup
      .string()
      .matches(/^\d+$/, "Phone number must contain only digits")
      .length(10, "Phone number must be exactly 10 digits")
      .required("Phone number is required"),
  });

  const onClientSave = async (values) => {
    console.log(values, "valuesvalues");
    setSubmitting(true);
    if (pathname == "/dashboard/editclient") {
      const data = await updateClientDetailsAdmin({
        ...values,
        id: state?._id,
      });
      if (data?.status == 200) {
        Swal.fire({
          icon: "success",
          title: "Client Edited Successfully",
          text: "",
        });
        navigate("/dashboard/client");
      } else {
        Swal.fire({
          icon: "error",
          title: data?.message,
          text: "",
        });
      }
    } else {
      const data = await addClient(values);

      if (data?.status == 201) {
        Swal.fire({
          icon: "success",
          title: "Client Added Successfully",
          text: "",
        });
        navigate("/dashboard/client");
      } else {
        Swal.fire({
          icon: "error",
          title: data?.data?.message,
          text: "",
        });
      }
    }
    setSubmitting(false);
  };

  return (
    <Div sx={{ mt: -4 }}>
      <Typography variant="h1">
        {pathname == "/dashboard/addclient" ? "Add New Client" : "Edit Client"}
      </Typography>
      <Div>
        <Formik
          validateOnChange={true}
          initialValues={client}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={onClientSave}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form noValidate autoComplete="off">
              <Div sx={{ mt: 4 }}>
                <Grid container rowSpacing={3} columnSpacing={3}>
                  <Grid item xs={4}>
                    <FormTextField1 name="first_name" label="First Name" />
                  </Grid>
                  <Grid item xs={4}>
                    <FormTextField1 name="last_name" label="Last Name" />
                  </Grid>
                  <Grid item xs={4}>
                    <FormTextField1 name="email_id" label="Email" />
                  </Grid>
                  <Grid item xs={4}>
                    <Div sx={outerDiv1}>
                      <Typography variant="h5">Phone No*</Typography>
                      <Div sx={{ display: "flex", mt: -1 }}>
                        <ListOptions
                          options={codeList}
                          name={"country_code"}
                          sx={{ width: "80px" }}
                        />
                        <FormTextField1
                          name="mobile_no"
                          sx={{ width: "100%" }}
                        />
                      </Div>
                    </Div>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="h5">Date Of Birth</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        sx={{
                          width: "100%",
                          "& .MuiInputBase-input": {
                            padding: 1,
                          },
                        }}
                        format="DD-MM-YYYY"
                        defaultValue={
                          values?.dob !== "" ? dayjs(values?.dob) : null
                        }
                        onChange={(newValue) => {
                          setFieldValue("dob", newValue.format("YYYY-MM-DD"));
                        }}
                      />
                    </LocalizationProvider>
                    <ErrorMessage
                      name="dob"
                      component="div"
                      style={{ color: "red" }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <ListOptions1
                      name="gender"
                      label="Gender"
                      options={genderList}
                    />
                  </Grid>

                  {/* <Grid item xs={4}>
                    <FormTextField1 name="age" label="Age" />
                  </Grid> */}
                </Grid>
                <Div sx={{ mt: 5 }}>
                  <Typography variant="h5">Status</Typography>
                  <Switch
                    onChange={(e) => {
                      setFieldValue(
                        "status",
                        values?.status == true ? false : true
                      );
                    }}
                    defaultChecked={values?.status == true ? true : false}
                    sx={{
                      p: 0,
                      width: "70px",
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: values?.status === true ? "green" : "red",
                        width: "90%",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                        {
                          backgroundColor:
                            values.status === true ? "green" : "red",
                        },
                    }}
                  />
                </Div>
                <Div
                  sx={{
                    width: "93.5%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 3,
                    mt: 3,
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure you want to cancel?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          navigate("/dashboard/client");
                        }
                      });
                    }}
                  >
                    Cancel
                  </Button>
                  <LoadingButton
                    variant="contained"
                    type="submit"
                    sx={{ width: "100px" }}
                    loading={isSubmitting}
                  >
                    Save
                  </LoadingButton>
                </Div>
              </Div>
            </Form>
          )}
        </Formik>
      </Div>
    </Div>
  );
}
